<template>
  <div class="home_index" ref="home_index">
    <div class="bg_box">
    </div>
      <div class="banner">
        <van-swipe :autoplay="3000" :show-indicators="false">
          <van-swipe-item v-for="(item, index) in bannerData" :key="index">
            <a :href="item.url">
              <van-image width="100%" height="100%" fit="cover" lazy-load :src="item.image">
                <template v-slot:error>加载失败</template>
              </van-image>
            </a>
          </van-swipe-item>
        </van-swipe>
      </div>
    
    <div class="index_box">
      <div class="typelist_box">
        <div class="typelist"  v-for="(item, index) in typeData" :key="index" @click="changetype(item.id)">
          <van-image :src="item.url" />
          <p>{{item.name}}</p>
        </div>
      </div>
      <div class="examlist_box">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getExamList"
          :immediate-check="false"
        >
          <div class="examlist" v-for="(item) in list" :key="item.id" @click="gotodetail(item.id)">
          {{item.title}}
          </div>
        </van-list>
      </div>
    </div>
    <tab-bar :current-index="0" />
  </div>
</template>
<script type="text/ecmascript-6">
import {
  Image as VanImage,
  Swipe as VanSwipe,
  SwipeItem as VanSwipeItem,
  Grid as VanGrid,
  GridItem as VanGridItem,
  List as VanList,
  Toast
} from 'vant';
import Vue from "vue";
import API from "../api";
import axios from "axios";
import TabBar from '../components/tabbar.vue';
export default {
  name: "",
  components: {
   TabBar,
   VanImage,
   VanSwipe,
   VanSwipeItem,
   VanGrid,
   VanGridItem,
   VanList,
  },
  data() {
    return {
      username: "",
      bannerData:{},
      typeData:{},
      typeId:this.$route.params.fid,
      list: [],
      loading: false,
      finished: false,
      listData:{},
      page:1,
      examid:0,
      size:15,
    };
  },
  computed: {
     
  },
  mounted() {
   this.getBanner();
   this.getType();
   
  },
  
  methods: {
    async getBanner(){
      const res = await API.getIndexBanner();
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.bannerData = res.data.data.list;
        //console.log(this.bannerData)
      } else {
        Toast(res.data.message);
      }
    },
    async getType(){
      //console.log(this.typeId)
      const res = await API.getIndexType({fid:this.typeId});
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.typeData = res.data.data;
        this.examid=this.typeData[0].id
        //console.log(this.examid)
        this.getExamList();
      } else {
        Toast(res.data.message);
      }
    },
    async getExamList() {
      if(!this.examid==0){
        //console.log(this.list)
        const res = await API.getExamList({typeid:this.examid,page:this.page,size:this.size});
        this.loading = false;
        if(res.data.code === 444){
          //console.log(res.data.data)
          window.location.href = res.data.data
        }else if (res.data.code === 200) {
          this.list.push(...res.data.data.list)
          // console.log(this.list.length,res.data.data.count,this.loading,this.page)
          if (this.list.length < res.data.data.count) {
          //console.log(2)
            this.page += 1;
          }else{
            this.finished = true;
          }
        } else {
          this.finished = true;
          Toast(res.data.message);
        }
      }
      
    },
    changetype(id){
      console.log(id);
      this.examid=id;
      //console.log(this.examid);
      this.page=1;
      this.list=[];
      this.loading = true;
      this.finished = false;
      this.getExamList();
    },
    gotodetail(id){
      //console.log(id);
      this.$router.push({ name: 'detail', params: { id: id } });
    }
  }
};
</script>



// WEBPACK FOOTER //
// typelist.vue?3c56f963